import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-982f79ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "epoch-list w-100" }
const _hoisted_2 = { class: "epoch-list__slot-count" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_4 = { class: "epoch-list__slot-percent-bar" }
const _hoisted_5 = { class: "w-100 mt-30 mb-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalSearchInput = _resolveComponent("GlobalSearchInput")!
  const _component_PageHeaderTitle = _resolveComponent("PageHeaderTitle")!
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_BANCard = _resolveComponent("BANCard")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_GhostListHeader = _resolveComponent("GhostListHeader")!
  const _component_BlockCardEpoch = _resolveComponent("BlockCardEpoch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GlobalSearchInput),
    _createVNode(_component_PageHeaderTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("Epochs")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      justify: "center",
      align: "middle",
      wrap: "",
      gutter: { lg: 16 }
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardDetails, (item) => {
          return (_openBlock(), _createBlock(_component_a_col, {
            lg: 8,
            xs: 24,
            key: item
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BANCard, {
                class: "mb-20",
                cardDetails: item,
                loading: !!_ctx.epochStatistics?.loading?.value,
                "unit-type": "blocks"
              }, {
                slots: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_AmountText, {
                      class: "d-inline",
                      amount: 432000,
                      minPrecision: 0
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_progress, {
                        "stroke-color": {
                    '0%': _ctx.lessVariable.customColor7,
                    '100%': _ctx.lessVariable.primaryColor,
                  },
                        percent: (item?.cardAmount / 432000) * 100,
                        showInfo: false
                      }, null, 8, ["stroke-color", "percent"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["cardDetails", "loading"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_GhostListHeader, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("Latest epochs")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { class: "ant-row ant-row-center" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_List, {
            class: "mb-10",
            "total-items": _ctx.mappedDataForDisplay.length,
            "data-source": _ctx.mappedDataForDisplay,
            loadMore: _ctx.showMore,
            "is-show-more-loading": _ctx.showMoreIsLoading,
            "is-loading": _ctx.isListLoading
          }, {
            renderItem: _withCtx(({ item }) => [
              _createVNode(_component_a_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: _ctx.gotoEpochDetails(item.epochNo)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BlockCardEpoch, {
                        itemDetails: item,
                        role: "button"
                      }, null, 8, ["itemDetails"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["total-items", "data-source", "loadMore", "is-show-more-loading", "is-loading"])
        ])
      ]),
      _: 1
    })
  ]))
}